import { forwardRef, Ref, useState } from 'react'
import { IconType } from 'react-icons'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import styled from 'styled-components'

export interface IProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string | JSX.Element
  isPasswordWithReveal?: boolean
  endIcon?: IconType
}

// eslint-disable-next-line react/display-name
export const Input = forwardRef(
  (
    { name, label, type, isPasswordWithReveal = false, endIcon: EndIcon, ...extraProps }: IProps,
    ref: Ref<HTMLInputElement>,
  ): JSX.Element => {
    const [inputType, setInputType] = useState(type || 'text')
    return (
      <Div>
        <label htmlFor={name}>
          {label && <div className="labelText">{label}</div>}
          <input ref={ref} type={inputType} name={name} id={name} {...extraProps} />
          {isPasswordWithReveal && (
            <span
              className="password-container-icon"
              onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}
            >
              {inputType === 'password' ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
            </span>
          )}
          {EndIcon && (
            <span>
              <EndIcon size={15} />
            </span>
          )}
        </label>
      </Div>
    )
  },
)

const Div = styled.div`
  width: 100%;

  label {
    position: relative;
    width: 100%;

    & > * {
      color: ${({ theme }) => theme.colors.grey.dark};
    }

    .password-container-icon svg {
      color: ${({ theme }) => theme.colors.grey.neutral};
    }

    input {
      ${({ theme }) => theme.typography.s.normal};

      color: ${({ theme }) => theme.colors.grey.dark};
      padding: 0.5rem 0.75rem;
      border: none;
      outline: 1px solid ${({ theme }) => theme.colors.grey.dark};
      border-radius: ${({ theme }) => theme.borderRadius.normal};
      width: 100%;

      &:focus {
        outline-color: ${({ theme }) => theme.colors.primary.light};
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.grey.dark}80;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }

    span {
      cursor: pointer;
      position: absolute;
      right: 1rem;
      margin-top: 0.5rem;
    }
  }

  .labelText {
    text-align: left;
    ${({ theme }) => theme.typography.xxs.normal};
    padding-bottom: 0.25rem;
  }
`
